import type { AutoRoomBookingMetricInfo } from 'owa-calendar-helpers-types/lib/AutoRoomBookingMetricInfo';
import { logUsage } from 'owa-analytics';

export default function logAutoRoomBookingMetric(
    formSessionId: string,
    metric: AutoRoomBookingMetricInfo
) {
    metric &&
        logUsage('AutoRoomBookingUsage', {
            formSessionId: formSessionId,
            ...metric,
        });
}
